import type { RouteObject } from "react-router-dom";
import PagePatient from "./page-patient";

export function RouterPatient(): RouteObject[] {
  return [
    {
      path: "/patient/:id/:selectedType?/:selectedId?/:mode?",
      element: <PagePatient />
    }
  ];
}
